<template>
  <div id="news">
    <div class="container">
      <div class="title_holder">
        <h3>{{ $t("nav.news") }}</h3>
        <div class="breadcrumbs">
          <ul>
            <li class="item-home">
              <router-link
                class="bread-link bread-home"
                :to="'/' + locale"
                title="Home"
                >{{ $t("nav.main") }}</router-link
              >
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <span class="bread-current">{{ $t("nav.news") }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container block-news">
      <div class="row">
        <template v-for="item in $store.state.GlobalData.news">
          <div class="col-md-4" v-if="item.status === 1" :key="item.id">
            <div class="item has_img">
              <div class="img_holder">
                <!-- <div class="time">
                <span></span>
                <h3>25</h3>
                <h5>Дек</h5>
                <h5>2019</h5>
              </div> -->
                <router-link
                  :to="`/` + locale + `/new/` + item.id"
                ></router-link>
                <img :src="item.images[0]" :alt="item.name[locale]" />
              </div>
              <div class="title_holder">
                <h3>
                  <router-link :to="`/` + locale + `/new/` + item.id">{{
                    item.name[locale]
                  }}</router-link>
                </h3>
                <p class="t_footer">
                  <router-link
                    class="bg"
                    :to="`/` + locale + `/new/` + item.id"
                    >{{ $t("more") }}</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      locale: this.$route.params.locale,
    };
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    },
  },
};
</script>

<style>
.title_holder {
  position: relative;
  padding: 95px 0 35px;
  width: 100%;
  float: left;
  clear: both;
}
.title_holder .breadcrumbs {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-top: 13px;
  padding-bottom: 2px;
}
.title_holder .breadcrumbs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.title_holder .breadcrumbs li {
  float: left;
  margin-bottom: 5px;
}
.title_holder .breadcrumbs li a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 1.5;
  font-weight: 600;
}
.title_holder .breadcrumbs .separator span {
  width: 33px;
  height: 24px;
  display: block;
  position: relative;
}
.title_holder .breadcrumbs .separator span:after,
.title_holder .breadcrumbs .separator span:before {
  width: 9px;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #ddd;
  left: 13px;
  content: "";
}
.title_holder .breadcrumbs .separator span:before {
  top: 14px;
  transform: rotate(135deg);
}
.title_holder .breadcrumbs .separator span:after {
  top: 8px;
  transform: rotate(45deg);
}
.title_holder:before {
  bottom: 13px;
  width: 150px;
  border-radius: 10px;
}
.title_holder:after {
  bottom: 0;
  width: 70px;
  border-radius: 10px;
}
.title_holder:before,
.title_holder:after {
  left: 0;
  position: absolute;
  height: 6px;
  background-color: #eee;
  content: "";
}
.block-news {
  margin-top: 30px;
  padding-bottom: 30px;
}
.block-news .title_holder:after,
.block-news .title_holder:before {
  content: none;
}
</style>
